export default __webpack_public_path__ + "static/media/LENS_ERVOIDES_TEKAY_fragment_5.45fc8020.jpg";